var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-text",attrs:{"v-bind":_vm.$attrs}},[_c('spinner'),_vm._v(" "),_c('span',{attrs:{"id":"loader-text"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }